import * as yup from "yup";

import { UserSummary } from "@/model/User/UserSummary";

export const EditDrillSessionValidation = (trainerOptions: UserSummary[]) => {
	const trainerIds = trainerOptions.map((x) => x.Id);

	return yup.object().shape({
		ResponsibleId: yup.number().test(
			"valid-trainer",
			"Select a trainer",
			(value) => trainerIds.includes(value), // any value as per request
		),
		KpiParameters: yup.array(),
	});
};
